import React, { useEffect, useState } from 'react';
import { api, dataHoraBR } from '../api';
import { Carregando, useToast } from '../components/Base';
import { ACOES } from './Painel';

export default function Logs() {
  const [lista, setLista] = useState(null);
  const [busca, setBusca] = useState('');
  const avisar = useToast();
  useEffect(() => { api('/logs').then(setLista).catch(e => avisar(e.message, 'erro')); }, [avisar]);
  if (!lista) return <Carregando />;
  const b = busca.trim().toLowerCase();
  const filtrada = b ? lista.filter(l => [l.acao, ACOES[l.acao], l.detalhe, l.admin_email, l.tenant_nome, l.tenant_id].some(v => String(v || '').toLowerCase().includes(b))) : lista;
  return (
    <>
      <div className="cartao" style={{ marginBottom: 14 }}>
        <div className="linha">
          <input placeholder="Filtrar por empresa, ação, quem fez…" value={busca} onChange={e => setBusca(e.target.value)}
            style={{ flex: 1, minWidth: 220, border: '1px solid var(--borda)', borderRadius: 6, padding: '8px 10px', minHeight: 36 }} />
          <span className="mudo pequeno">{filtrada.length} de {lista.length} (últimas 300)</span>
        </div>
      </div>
      <div className="cartao tabela-wrap mob-cards" style={{ padding: 0 }}>
        <table>
          <thead><tr><th>Quando</th><th>Quem</th><th>Ação</th><th>Empresa</th><th>Detalhe</th></tr></thead>
          <tbody>
            {filtrada.length === 0 && <tr><td colSpan="5" className="vazio">Nada registrado.</td></tr>}
            {filtrada.map(l => (
              <tr key={l.id}>
                <td data-label="Quando" style={{ whiteSpace: 'nowrap' }}>{dataHoraBR(l.criado_em)}</td>
                <td data-label="Quem">{l.admin_email || <span className="mudo">automático</span>}</td>
                <td data-label="Ação">{ACOES[l.acao] || l.acao}</td>
                <td data-label="Empresa">{l.tenant_id ? <a href={'#/empresas/' + l.tenant_id}>{l.tenant_nome || '#' + l.tenant_id}</a> : '—'}</td>
                <td data-label="Detalhe">{l.detalhe}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </>
  );
}
